// extracted by mini-css-extract-plugin
var _1 = "InputTabs-module__active--Xtju5";
var _2 = "InputTabs-module__animateUploadProgressBarWidth--jdnsr";
var _3 = "InputTabs-module__animatedBackground--EF8Z_";
var _4 = "InputTabs-module__container--Kap5Q";
var _5 = "InputTabs-module__inputContainer--WuFeX";
var _6 = "InputTabs-module__list--QPG1g";
var _7 = "InputTabs-module__saveButton--NVx68";
var _8 = "InputTabs-module__tabItem--e0R9M";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "inputContainer", _6 as "list", _7 as "saveButton", _8 as "tabItem" }
